import React from 'react';
import {
  Show as RaShow,
  Tab,
  TextField,
  DateField,
  FunctionField,
  TabbedShowLayout,
  SimpleShowLayout,
  BooleanField,
} from 'react-admin';
import { DataGrid } from '@mui/x-data-grid';

import { TextFieldWithCopy } from '../../components/TextFieldWithCopy';
import { usePageTitle } from '../../components/usePageTitle';
import { useStyles } from './styles';

export const Show = (props) => {
  usePageTitle(props);
  const classes = useStyles();
  const columns = [
    { field: 'id', headerName: 'ID', sortable: false },
    { field: 'name', headerName: 'Name', sortable: false },
    {
      field: 'is_system',
      headerName: 'Is system',
      sortable: false,
    },
  ];

  return (
    <>
      <RaShow {...props}>
        <SimpleShowLayout>
          <TabbedShowLayout className={classes.tabContainer}>
            <Tab label="general">
              <SimpleShowLayout className={classes.formContainer}>
                <SimpleShowLayout className={classes.formColumnContainer}>
                  <TextFieldWithCopy source="id" />
                  <TextFieldWithCopy
                    sortable={false}
                    source="user_account_id"
                    label="User account ID"
                  />
                  <TextField
                    sortable={false}
                    source="holder_name"
                    label="Holder name"
                  />
                  <TextField
                    sortable={false}
                    source="holder_address"
                    label="Holder adress"
                  />
                  <TextField sortable={false} source="mask" label="Mask" />
                  <TextField
                    sortable={false}
                    source="description"
                    label="Description"
                  />
                  <TextField
                    sortable={false}
                    source="favorite"
                    label="Favorite"
                  />
                  <TextField sortable={false} source="status" label="Status" />
                  <DateField sortable={false} source="ordered_at" />
                  <DateField sortable={false} source="ordered_until" />
                  <BooleanField
                    sortable={false}
                    source="topup_waiting"
                    label="Topup waiting"
                  />
                  <TextFieldWithCopy
                    sortable={false}
                    source="tariff_id"
                    label="Tariff id"
                  />
                  <BooleanField
                    sortable={false}
                    source="need_amount"
                    label="Need amount"
                  />
                  <BooleanField
                    sortable={false}
                    source="limits_equals"
                    label="Limit equals"
                  />
                  <DateField sortable={false} source="created_at" />
                </SimpleShowLayout>
              </SimpleShowLayout>
            </Tab>
            <Tab label="Details">
              <SimpleShowLayout>
                <TextFieldWithCopy label="Card number" source="details.number" />
                <TextFieldWithCopy label="Card CVV" source="details.cvx2" />
                <FunctionField
                  label="Expiration date"
                  render={({ details }) => (
                    <span>
                      {details?.exp_month}
                      /
                      {details?.exp_year}
                    </span>
                  )}
                />
              </SimpleShowLayout>
            </Tab>

            <Tab label="Account">
              <TextFieldWithCopy label="Account ID" source="account.id" />
              <TextField label="Type" source="account.type" />
              <TextField label="Currency ID" source="account.currency_id" />
              <TextField label="Iban" source="account.iban" />
              <TextField label="Balance" source="account.balance" />
              <TextField label="Addresses" source="account.addresses" />
              <FunctionField
                label="Positive transactions sum"
                render={(record) => (
                  <span>
                    {Number(
                      record.account.summary.positive_transactions_sum,
                    ).toFixed(2)}
                  </span>
                )}
              />
              <FunctionField
                label="Negative transactions sum"
                render={(record) => (
                  <span>
                    {Number(
                      record.account.summary.negative_transactions_sum,
                    ).toFixed(2)}
                  </span>
                )}
              />
              <TextField
                label="Positive transactions count"
                source="account.summary.positive_transactions_count"
              />
              <TextField
                label="Negative transactions count"
                source="account.summary.negative_transactions_count"
              />
            </Tab>
            <Tab label="Auto refill">
              <TextFieldWithCopy
                label="Auto refill ID"
                source="auto_refill.id"
              />
              <TextFieldWithCopy label="Card id" source="auto_refill.card_id" />
              <TextField
                label="Minimum balance"
                source="auto_refill.minimum_balance"
              />
              <TextField
                label="Amount refill"
                source="auto_refill.amount_refill"
              />
              <TextField label="Active" source="auto_refill.active" />
              <DateField label="Created At" source="auto_refill.created_at" />
              <DateField label="Updated At" source="auto_refill.updated_at" />
              <DateField label="Deleted At" source="auto_refill.deleted_at" />
            </Tab>

            <Tab label="Tags">
              <FunctionField
                label="Tags"
                render={({ tags }) => (
                  tags.length && (
                  <DataGrid
                    disableColumnFilter
                    disableColumnMenu
                    hideFooter
                    rows={tags}
                    columns={[...columns]}
                  />
                  )
                )}
              />
            </Tab>
          </TabbedShowLayout>
        </SimpleShowLayout>
      </RaShow>
    </>
  );
};
